// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class OrganizationUserResetPasswordRequest {
  newMasterPasswordHash: string;
  key: string;
}
